import React, { useEffect, useState } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import axios from '../api/axios'
import { API_ENDPOINTS } from '../api/endpoint'
import PvPInvitationModal from '../components/PvPInvitationModal'

function MainLayout() {
  const [pvpInvitation, setPvpInvitation] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is logged in (has token)
    const token = localStorage.getItem('token') || localStorage.getItem('session_token');
    if (!token) {
      return; // User not logged in, no need for keep-alive
    }
    
    // Keep-alive function - updates user's online status
    const keepAlive = async () => {
      try {
        await axios.post(API_ENDPOINTS.KEEP_ALIVE);
        console.log('[Keep-Alive] Online status updated');
      } catch (error) {
        console.error('[Keep-Alive] Error:', error);
        // Don't show error to user, just log it
      }
    };
    
    // Check for active PVP battle and redirect if needed
    const checkActivePvPBattle = async () => {
      // Don't redirect if already on PVP page
      if (location.pathname === '/pvp') {
        return;
      }
      
      try {
        const response = await axios.get(API_ENDPOINTS.GET_ACTIVE_PVP_BATTLE);
        if (response.data && response.data.success && response.data.has_active_battle) {
          const battleId = response.data.battle_id;
          console.log('[Active PVP Battle] Found active battle, redirecting to:', battleId);
          navigate(`/pvp?battle_id=${battleId}&pvp=true`);
        }
      } catch (error) {
        console.error('[Active PVP Battle] Error:', error);
      }
    };
    
    // Check for PVP invitations
    const checkPvPInvitations = async () => {
      // Only check if user is on home page
      const currentPath = location.pathname;
      console.log('[PVP Invitations] Checking invitations, current path:', currentPath);
      
      if (currentPath !== '/home') {
        // Clear invitation if user navigated away from home
        if (pvpInvitation) {
          console.log('[PVP Invitations] User not on home page, clearing invitation');
          setPvpInvitation(null);
        }
        return;
      }
      
      // Don't check if there's an active battle
      const activeBattle = localStorage.getItem('activeBattle');
      if (activeBattle) {
        // Clear invitation if there's an active battle
        if (pvpInvitation) {
          console.log('[PVP Invitations] Active battle detected, clearing invitation');
          setPvpInvitation(null);
        }
        return;
      }
      
      try {
        console.log('[PVP Invitations] Fetching invitations from API...');
        const response = await axios.get(API_ENDPOINTS.GET_PVP_INVITATIONS);
        console.log('[PVP Invitations] API Response:', response.data);
        
        if (response.data && response.data.success && response.data.invitations && response.data.invitations.length > 0) {
          // Get the most recent pending invitation
          const latestInvitation = response.data.invitations[0];
          console.log('[PVP Invitations] Found invitation:', latestInvitation);
          
          // Only show if we don't already have one displayed or if it's a different one
          if (!pvpInvitation || pvpInvitation.id !== latestInvitation.id) {
            console.log('[PVP Invitations] Setting new invitation in state');
            setPvpInvitation(latestInvitation);
          } else {
            console.log('[PVP Invitations] Invitation already displayed');
          }
        } else {
          console.log('[PVP Invitations] No invitations found');
          // No invitations, clear any existing one
          if (pvpInvitation) {
            setPvpInvitation(null);
          }
        }
      } catch (error) {
        console.error('[PVP Invitations] Error:', error);
        console.error('[PVP Invitations] Error response:', error.response);
        // Don't show error to user, just log it
      }
    };
    
    // Call immediately when component mounts
    keepAlive();
    checkPvPInvitations();
    checkActivePvPBattle();
    
    // Then call every 2 minutes (120000 ms) to keep user online
    const keepAliveInterval = setInterval(keepAlive, 120000);
    
    // Check for PVP invitations every 5 seconds
    const invitationInterval = setInterval(checkPvPInvitations, 5000);
    
    // Check for active PVP battle every 3 seconds
    const activeBattleInterval = setInterval(checkActivePvPBattle, 3000);
    
    // Cleanup on unmount
    return () => {
      clearInterval(keepAliveInterval);
      clearInterval(invitationInterval);
      clearInterval(activeBattleInterval);
    };
  }, [pvpInvitation, location.pathname]); // Include location.pathname in dependencies
  
  // Only show invitation modal on home page and if there's no active battle
  const currentPath = location.pathname;
  const activeBattle = localStorage.getItem('activeBattle');
  const shouldShowInvitation = currentPath === '/home' && 
                                pvpInvitation && 
                                !activeBattle;
  
  console.log('[PVP Invitations] Render check:', {
    currentPath,
    hasInvitation: !!pvpInvitation,
    activeBattle: !!activeBattle,
    shouldShow: shouldShowInvitation
  });
  
  return (
    <div>
      <Outlet/>
      {shouldShowInvitation && (
        <PvPInvitationModal
          invitation={pvpInvitation}
          onAccept={() => {
            console.log('[PVP Invitations] Invitation accepted');
            setPvpInvitation(null);
          }}
          onDecline={() => {
            console.log('[PVP Invitations] Invitation declined');
            setPvpInvitation(null);
          }}
          onClose={() => {
            console.log('[PVP Invitations] Invitation closed');
            setPvpInvitation(null);
          }}
        />
      )}
    </div>
  )
}

export default MainLayout
